(function () {
    'use strict';

    angular
        .module('oddPublicModule')
        .controller('QuestionAttachmentController', Controller);

    Controller.$inject = ['$scope', '$timeout', 'attachmentService'];

    function Controller($scope, $timeout, attachmentService) {
        var form;
        $scope.upload = {
            _uploading: {},
            _uploaded: {},
            _inError: {},
            _fileDownloading: {},
            _errorIndex: 0
        };

        if ($scope.ctxtCtrl.attachments && $scope.ctxtCtrl.attachments.length > 0) {
            $scope.ctxtCtrl.attachments.forEach(function (attachment) {
                if (!$scope.recordID || ($scope.recordID === attachment.RecordID)) {
                    $scope.upload._uploaded[attachment.QuesCompAttachID] = $scope.upload._uploaded[attachment.QuesCompAttachID] || [];
                    $scope.upload._uploaded[attachment.QuesCompAttachID].push({
                        fileName: attachment.FileName,
                        label: attachment.Label,
                        compAttachmentId: attachment.QuestCompAttachID,
                        blobID: attachment.BlobID
                    });
                    $scope.addAttachmentFileName(attachment.FileName);
                }
            })
        }

        $scope.fileUploadChanged = function (compAttachmentId, label, files, questionAttachment, questionFieldId, recordId) {
            // Validate uniqueness of file names
            validateFileNames(files, compAttachmentId);

            // List file names that are loading
            $scope.upload._uploading[compAttachmentId] = $scope.upload._uploading[compAttachmentId] || [];
            if (_.isArray(files) && files.length > 0) {
                files.forEach(function (file) {
                    $scope.upload._uploading[compAttachmentId].push(file);
                    ++$scope.campaignContext.attachmentUploading;
                });
            }

            if (files) {
                // Clear Field
                $scope.upload[label] = [];

                // Upload Files
                $scope.filesAttached(compAttachmentId, label, files, uploadError.bind(this, $scope), questionFieldId, recordId)
                    .then(function (uploaded) {
                        if (uploaded !== null && _.isArray(uploaded)) {
                            $scope.templateSaveAnswer();
                            $scope.upload._uploaded[compAttachmentId] = $scope.upload._uploaded[compAttachmentId] || [];
                            uploaded.forEach(function (savedFile) {
                                --$scope.campaignContext.attachmentUploading;
                                $scope.upload._uploading[compAttachmentId].some(function (tempFile, idx) {
                                    if (tempFile.name === savedFile.fileName) {
                                        $scope.upload._uploading[compAttachmentId].splice(idx, 1);
                                        $scope.upload._uploaded[compAttachmentId].push(savedFile);
                                        return true;
                                    }
                                    return false;
                                })
                            });
                            validateAttachmentComponent(questionAttachment);
                        }
                    });
            }

        };

        $scope.downloadAttachment = function (compAttachmentId, blobId) {
            $scope.upload._fileDownloading[compAttachmentId] = null;
            $timeout(function () {
                $scope.upload._fileDownloading[compAttachmentId] = $scope.getDownloadAttachmentUrl(blobId);
                attachmentService.downloadFile(blobId);
            }, 0)
        };

        $scope.removeAttachment = function (compAttachmentId, blobId, file, questionAttachment) {
            // if already removing, do not try to remove again
            if (file._removing) return;

            ++$scope.campaignContext.attachmentUploading;
            file._removing = true;
            $scope.deleteAttachment(blobId, file.fileName)
                .then(function () {
                    var idx = _.findIndex($scope.upload._uploaded[compAttachmentId], {blobID: blobId});
                    if (idx > -1) {
                        $scope.upload._uploaded[compAttachmentId].splice(idx, 1);
                    }
                })
                .finally(function () {
                    file._removing = false;
                    --$scope.campaignContext.attachmentUploading;
                    validateAttachmentComponent(questionAttachment);
                });
        };

        function validateFileNames(files, compAttachmentId) {
            // remove error messages with error and display in list of error files
            $scope.upload._inError[compAttachmentId] = $scope.upload._inError[compAttachmentId] || [];
            files.forEach(function (file, idx) {
                var valid = $scope.validateAttachmentUniqueName(file);
                if (!valid) {
                    $scope.upload._inError[compAttachmentId].push({
                        name: file.name,
                        error: 'A file with the same name has already been attached to the question. Please rename your file.',
                        index: $scope.upload._errorIndex
                    });
                    planToRemoveErrorFile($scope, compAttachmentId, $scope.upload._errorIndex);
                    files.splice(idx, 1);
                    ++$scope.upload._errorIndex
                }
            });
        }

        function uploadError(scope, error, compAttachmentId, label, files) {
            scope.upload._inError[compAttachmentId] = scope.upload._inError[compAttachmentId] || [];
            files.forEach(function (file) {
                --$scope.campaignContext.attachmentUploading;
                scope.upload._uploading[compAttachmentId].some(function (uploading, idx) {
                    if (uploading.name === file.name) {
                        scope.upload._inError[compAttachmentId].push({
                            name: file.name,
                            error: error.message,
                            index: scope.upload._errorIndex
                        });
                        planToRemoveErrorFile(scope, compAttachmentId, scope.upload._errorIndex);
                        scope.upload._uploading[compAttachmentId].splice(idx, 1);
                        ++scope.upload._errorIndex;
                        return true;
                    }
                    return false;
                })
            })
        }

        function planToRemoveErrorFile(scope, compAttachmentId, index) {
            var idx = _.clone(index);

            $timeout(function () {
                var i = _.findIndex(scope.upload._inError[compAttachmentId], {'index': idx});
                if (i > -1) {
                    scope.upload._inError[compAttachmentId].splice(i, 1);
                }
            }, 5000);
        }

        function validateAttachmentComponent(questionAttachment) {
            if (questionAttachment && questionAttachment.IsRequired === 'true'
                && (!$scope.campaign.answerByQuestionID[questionAttachment.QuestionID]
                    || !$scope.campaign.answerByQuestionID[questionAttachment.QuestionID].isReadOnly)) {

                form[$scope.getAttachmentInputName(questionAttachment.QuestionComponentAttachmentID)].$setValidity('requiredAttachments',
                    $scope.upload._uploaded[questionAttachment.QuestionComponentAttachmentID].length > 0);
            }
        }

        $timeout(function () {
            form = $scope[$scope.getAttachmentFormName()];

            var questAttachments = null;
            if ($scope.field) {
                questAttachments = $scope.field.QuestionAttachments;
            } else {
                questAttachments = $scope.component.QuestionAttachments;
            }

            // For each attachment component
            if (questAttachments) {
                questAttachments.forEach(function (qAttachment) {
                    $scope.upload._uploaded[qAttachment.QuestionComponentAttachmentID] = $scope.upload._uploaded[qAttachment.QuestionComponentAttachmentID] || [];
                    validateAttachmentComponent(qAttachment);
                });
            }
        }, 0);
    }
})();
